export default __webpack_public_path__ + "static/media/img4.5b648b51.png";